import { ACCOUNT_SETTINGS_ROUTE } from "../routes.definitions";

export const USER_API_KEYS_ROUTE = {
  TITLE: "Personal Access Tokens",
  KEY: "user-api-keys",
  ABSOLUTE_PATH: `${ACCOUNT_SETTINGS_ROUTE.ABSOLUTE_PATH}/user-api-keys`,
};
